module.exports = __webpack_public_path__ + "static/work-preformance-d009a19da5eb5beb4402903bc037820e.png";